// If in react component use "useEffect" -> is called when on client
export const isBrowser = () => {
  return typeof window !== "undefined";
};

export const setCookie = (name, value, days) => {
  if (!isBrowser()) {
    return;
  }
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name + "=" + (value || "") + expires + ";path=/;SameSite=Lax";
};

export const getCookie = (name) => {
  if (!isBrowser()) {
    return;
  }
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name) => {
  if (!isBrowser()) {
    return;
  }
  document.cookie = name + "=; Max-Age=-99999999;path=/;";
};
